import { ChangeDetectionStrategy, Component, Input, OnDestroy, Output } from '@angular/core'
import { ReplaySubject, Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { MoreNodesSelected, VideoEndedEvent } from '../../../../collections/collections.models'
import { trackById } from '../../../../shared/utility-functions/track-by-id.utility'
import { getAnalytics } from '../../../collections/functions/analytics'
import { getEventListItemComponentProps } from '../event-list-item/event-list-item.component'
import { CollectionChildNodesRequestParams } from 'src/io/models/http/collection-child-nodes-request-params'
import { Node } from 'src/io/models/node'
import { FloGeoEvent } from 'src/app/events/interfaces/flo-geo-event.interface'
import { ActivatedRoute } from '@angular/router'

export interface NodeListComponentProps {
  nodes: ReadonlyArray<Node>
  nodesRequestParams: CollectionChildNodesRequestParams
  selectedNode?: Node
}

@Component({
  selector: 'flo-event-filter-list',
  templateUrl: `./event-filter-list.component.html`,
  styles: [
    `
      flo-event-list-item:first-child {
        border-top: 1px solid #f5f5f7;
        margin-top: 30px;
      }
      .empty-text {
        margin: 30px 0;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventFilterListComponent implements OnDestroy {
  constructor(private readonly activatedRoute: ActivatedRoute) {}

  private ngOnDestroy$ = new ReplaySubject<void>(1)

  private readonly props$ = new ReplaySubject<NodeListComponentProps>(1)
  @Input()
  set props(props: NodeListComponentProps) {
    if (!!props) {
      this.props$.next(props)
    }
  }

  @Output()
  public readonly action$ = new Subject<MoreNodesSelected | VideoEndedEvent>()

  public readonly listItemProps$ = this.props$.pipe(
    map(props => props.nodes),
    map(nodes =>
      nodes.map((node, i, arr) => {
        return {
          ...getEventListItemComponentProps(
            node as unknown as FloGeoEvent,
            getAnalytics(node as unknown as FloGeoEvent, i, arr.length),
            i
          ),
          type: 'event'
        }
      })
    )
  )

  public eventFilterLinkProps$ = this.props$.pipe(
    map(props => [
      {
        name: 'Completed',
        value: 'Completed',
        active: props.nodesRequestParams.view === 'Completed'
      },
      {
        name: 'Live & Upcoming',
        value: 'live-and-upcoming',
        active: props.nodesRequestParams.view === 'live-and-upcoming'
      }
    ])
  )

  public readonly emptyListText$ = this.props$.pipe(
    map(props =>
      props.nodes.length
        ? undefined
        : `There are currently no ${
            props.nodesRequestParams.view === 'Completed' ? 'completed' : 'live or upcoming'
          } events.`
    )
  )

  public readonly navId = this.activatedRoute.snapshot.queryParamMap.get('nav_id')

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next()
    this.ngOnDestroy$.complete()
  }

  public trackById = trackById
}
